<script setup lang="ts">
  import { useI18n } from 'vue-i18n'

  import { useTopic } from '@/composables/useTopic'

  import AnchorNavigationTemplate from '@/components/anchor-navigation/AnchorNavigationTemplate.vue'
  import VgsSpinner from '@/components/common/VgsSpinner.vue'

  const { t } = useI18n()
  
  const { currentTopic, topicGuide, isLoading } = useTopic()
</script>

<template>
  <VgsSpinner :is-loading="isLoading" />
  <AnchorNavigationTemplate
    v-if="topicGuide && !isLoading"
    :content="topicGuide"
    :top-section-title="t('subject.to-teacher')"
    :top-section-super-title="currentTopic?.title"
  />
</template>
